import { JwtHelperService } from '@auth0/angular-jwt';
import { DateTime } from 'luxon';

export abstract class RefreshComponent {
  private sessionTimeout!: ReturnType<typeof setTimeout>;
  public jwtHelper: JwtHelperService = new JwtHelperService();

  startRefreshSession(token: string): void {
    if (this.sessionTimeout) {
      clearTimeout(this.sessionTimeout);
    }
    this.checkToken(token);
  }

  checkToken(token: string): any {
    const expiration: DateTime = DateTime.fromJSDate(this.getTokenExpirationDate(token) || new Date());
    const resetMiliseconds: number = expiration.minus({ seconds: 60 }).diff(DateTime.now(), 'milliseconds').toMillis();
    if (resetMiliseconds <= 0) {
      this.refreshToken();
      return;
    }
    this.sessionTimeout = setTimeout(() => this.refreshToken(), resetMiliseconds);
  }

  abstract refreshToken(): any;
  abstract getTokenExpirationDate(token: string): any;
}
